interface EventSetCareProgram {
  id: number | string;
}

export const EVENT_SET_CARE_PROGRAM = 'set-care-program';

export const eventCareProgram = {
  setId: (id: EventSetCareProgram['id']) => {
    window.dispatchEvent(
      new CustomEvent<EventSetCareProgram>(EVENT_SET_CARE_PROGRAM, {
        detail: { id }
      })
    );
  },

  onIdChange: (callback: (id: EventSetCareProgram['id']) => void) => {
    const handler = (e: CustomEvent<EventSetCareProgram>) => {
      callback(e.detail.id);
    };

    window.addEventListener(EVENT_SET_CARE_PROGRAM, handler as EventListener);
    return () => {
      window.removeEventListener(
        EVENT_SET_CARE_PROGRAM,
        handler as EventListener
      );
    };
  }
};
